__turbopack_context__.v({
  "circle": "t6jEPG_circle",
  "dots": "t6jEPG_dots",
  "partialAccordionTitle": "t6jEPG_partialAccordionTitle",
  "sideText": "t6jEPG_sideText",
  "step": "t6jEPG_step",
  "stepDecoration": "t6jEPG_stepDecoration",
  "steps": "t6jEPG_steps",
});
